import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { LoadingState } from '@/components/ui';
import { AppDataProvider } from './providers/AppDataProvider';
import { router } from './router';

export function App() {
  return (
    <AppDataProvider>
      <Suspense fallback={<LoadingState label="Starting 1XI" />}>
        <RouterProvider router={router} />
      </Suspense>
    </AppDataProvider>
  );
}
